module.exports = __webpack_public_path__ + "img/bilboard-mobil.a570a5b0.webp";